import React, {Fragment, useContext} from "react";
import PropTypes from "prop-types";
import SpinnerDiv from "root/Components/SpinnerDiv";
import PassportTable, {xlateBootstrapTableColumns} from "root/Tables/PassportTable";
import {
    defaultTableHeaderStyles,
    defaultPaginationOptions,
    customHeaderStyle,
    defaultTopLeftCellStyle,
    defaultTopRightCellStyle,
    TableActionIconEmail,
    TableActionIconChart,
    TableActionIconSuspend,
    TableActionIconEdit,
    TableActionIconPassword,
    TableActionIconActivate,
    TableActionIconView,
    TableActionIconManage,
    TableActionIconDelete
} from "./BaseTableComponents";

import './Table.scss'
import {getMyContributorsRouterLink, getUsersRouterLink} from "root/Wieldy/routePaths";
import phpVars from 'phpVars';
import {UserGroupTypes, UserRoleGroups, UserTypes} from "root/DataFunctions/Constants";
import {ApplicationTypes, doesUserHaveApplication} from "root/DataFunctions/PageContentRoles";
import GlobalContext from "root/contexts/GlobalContext";

const UsersTable = (props) =>
{
    const globals = useContext(GlobalContext);

    const onClickItem = (user_id, mode, role, name) =>
    {
        props.clickHandler(user_id,  mode, role, name);
    }

    const linkFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        const connectionsLink = getUsersRouterLink(row.idusers + '/connections?name=' + row.name);
        const usersDashboardLink = getUsersRouterLink(row.idusers + '/dashboard?type=summary&name=' + row.name + '&userType=' + row.userTypeId);
        const myContributorsDashboardLink = getMyContributorsRouterLink(row.idusers + '/dashboard?type=summary&name=' + row.name + '&userType=' + row.userTypeId);

        const isStaff = phpVars.user_type_group === UserGroupTypes.USER_GROUP_STAFF;
        const canManageUserRights = doesUserHaveApplication(ApplicationTypes.ORGANISATION_ADMIN, globals.userType) && UserRoleGroups.CAN_BE_STAFF.includes(+(row.userTypeId));

        return (
            <Fragment>
                {isStaff && <TableActionIconView text="Manage User's Connections" to={connectionsLink} />}
                {canManageUserRights && <TableActionIconManage text="Manage User's Rights" onClick={() => onClickItem(row.idusers,'rights',  null, row.name)} />}

                {isStaff && <TableActionIconChart text="View User's Stats" to={usersDashboardLink} />}
                {!isStaff && <TableActionIconChart text="View Contributor's Stats" to={myContributorsDashboardLink} />}

                <TableActionIconEdit text="Edit User" onClick={() => onClickItem(row.idusers,'edit',  row.typeName)} />

                { row.us_description === 'Active' && <TableActionIconPassword text="Change Password" onClick={() => onClickItem(row.idusers, 'password')} />}

                { (row.us_description === 'Invited' || row.us_description === 'Re-invited' || row.us_description === 'Expired') && <TableActionIconEmail text="Invite Again" onClick={() => onClickItem(row.idusers, 'invite')} />}

                { row.us_description === 'Active' && <TableActionIconSuspend text="Suspend User" onClick={() => onClickItem(row.idusers, 'suspend')} />}

                { row.us_description === 'Suspended' && <TableActionIconActivate text="Activate User" onClick={() => onClickItem(row.idusers, 'activate')} />}

                <TableActionIconDelete text="Archive User" onClick={() => onClickItem(row.idusers, 'delete')} />
            </Fragment>
        );
    }

    const statusFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        let color = "#216C06";

        if (cell === "Suspended" || cell === "Expired") {
            color = "#E00909";
        }

        if (cell === "Invited" || cell === "Re-invited") {
            color = "#E1720B";
        }

        return <div style={{ borderRadius: "5px", color: color }}>{cell}</div>;
    }

    const headerStyle = customHeaderStyle.bind(null, {
        default: defaultTableHeaderStyles,
        firstname: {borderRadius: defaultTopLeftCellStyle, width: "12vw"},
        surname: { width: "15vw"},
        username: {width: "15vw"},
        typeName: {width: "12vw"},
        options: {borderRadius: defaultTopRightCellStyle, textAlign: 'right', width: "15vw"}
    });

    const getColumns = () => {
        const columns = [
            {
                dataField: "firstname",
                text: "Firstname",
                headerStyle: headerStyle
            },
            {
                dataField: "surname",
                text: "Surname",
                sort: true,
                headerStyle: headerStyle
            },
            {
                dataField: "username",
                text: "Username",
                headerStyle: headerStyle
            },
            {
                dataField: "description",
                text: "Short Name",
                headerStyle: headerStyle
            },
            {
                dataField: "us_description",
                text: "Account Status",
                formatter: statusFormatter,
                headerStyle: headerStyle
            },
            {
                dataField: "options",
                text: "Options",
                formatter: linkFormatter,
                align: 'right',
                headerStyle: headerStyle
            },
        ];

        return columns;
    };

    const translations = xlateBootstrapTableColumns(getColumns());
    const columns = React.useMemo(() => translations, []);

    const thisTableContent = () =>
    {
        return <PassportTable data={props.data} columns={columns} pagination={defaultPaginationOptions}/>
    }

    return props.loading === true ? <SpinnerDiv/> : thisTableContent();
};

export default UsersTable;

UsersTable.propTypes = {
    user_id: PropTypes.string,
    data: PropTypes.array,
    loading: PropTypes.bool
};
